import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import numeral from "numeral";

const Highcharts = window.Highcharts;
const HighchartsReact = window.HighchartsReact;

const breakdownOptions = (data, selectedStateName, isOtherState) => {
  const mapValues = (path) => (_.get(data, path, 0));

  return {
    chart: {
      type: "line",
      height: 500,
      width: 400,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: `Spending Over Time, 2011-2030 - ${selectedStateName}${isOtherState ? ", Other States" : ""}`,
      style: {
        fontWeight: "bold"
      }
    },
    exporting: {
      enabled: false
    },
    legend: {
      backgroundColor: "#e5e3e3",
      padding: 20,
      align: "right",
      margin: 10,
      itemMarginBottom: 4,
      itemMarginTop: 1,
      itemStyle: {
        fontWeight: "normal"
      },
      layout: "horizontal",
      symbolHeight: 14,
      symbolWidth: 14,
      symbolRadius: 0,
      reversed: true,
    },
    plotOptions: {
      series: {
        pointStart: 2011
      }
    },
    tooltip: {
      animation: true,
      backgroundColor: "transparent",
      borderWidth: 0,
      formatter: function() {
        return `
          <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
            <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
            <b>${selectedStateName}</b></br>
            ${this.series.name}</br>
            ${this.key}
            </div>
            <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
              <div style="color: ${this.color}; font-weight: bold">
                ${this.series.tooltipOptions.valuePrefix}${numeral(this.point.y).format("0,0")}${this.series.tooltipOptions.valueSuffix}</b>
              </div>
            </div>
          </div>
        `;
      },
      hideDelay: 100,
      shadow: false,
      shape: "square",
      style: { color: "black", padding: 0 },
      useHTML: true,
      valuePrefix: "$",
      valueSuffix: "m"
    },
    xAxis: {
      lineWidth: 0,
      tickLength: 5,
    },
    yAxis: {
      labels: {
        formatter: function() {
          return numeral(this.value).format("0,0");
        }
      },
      min: 0,
      title: {
        text: "$m",
        rotation: 0,
        x: -5
      },
    },
    series: [
      {
        name: "Water CAPEX",
        data: mapValues("water_capex"),
        color: "#54925b",
      },
      {
        name: "Water OPEX",
        data: mapValues("water_opex"),
        color: "#f4b447",
      },
      {
        name: "Wastewater CAPEX",
        data: mapValues("wastewater_capex"),
        color: "#4fbded",
      },
      {
        name: "Wastewater OPEX",
        data: mapValues("wastewater_opex"),
        color: "#ca3d3c",
      },
    ],
  };
};

const SpendingOverTime = ({ data, selectedStateName, isOtherState }) => <HighchartsReact
  highcharts={Highcharts}
  constructorType={"chart"}
  options={breakdownOptions(data, selectedStateName, isOtherState)}
/>;

SpendingOverTime.propTypes = {
  data: PropTypes.shape({}).isRequired,
  selectedStateName: PropTypes.string.isRequired,
  isOtherState: PropTypes.bool.isRequired
};

export default SpendingOverTime;
